var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"homepage-title"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"col",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }